import { useState } from 'react';

const BeforeAfterSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      before: 'https://public.readdy.ai/ai/img_res/8ac2783f53b9da87f1772cef7de40774.jpg',
      after: 'https://readdy.ai/api/search-image?query=After%20photo%20body%20transformation%20result%2C%20woman%20with%20improved%20body%20contour%2C%20toned%20silhouette%2C%20simple%20white%20background%2C%20professional%20after%20treatment%20photo%2C%20confident%20posture%2C%20visible%20body%20improvement%2C%20successful%20body%20sculpting%20result&width=600&height=800&seq=after-001&orientation=portrait',
      treatment: 'Fit Carving ボディメイクコース',
      period: '3ヶ月（週1回×12回）',
    },
    {
      before: 'https://readdy.ai/api/search-image?query=Before%20facial%20skin%20close-up%2C%20woman%20face%20with%20visible%20pores%20and%20dullness%2C%20simple%20white%20background%2C%20professional%20skin%20assessment%20photo%2C%20neutral%20expression%2C%20clinical%20documentation%2C%20before%20skincare%20treatment&width=600&height=800&seq=before-002&orientation=portrait',
      after: 'https://readdy.ai/api/search-image?query=After%20facial%20treatment%20result%2C%20woman%20with%20glowing%20clear%20skin%2C%20improved%20skin%20texture%2C%20radiant%20complexion%2C%20simple%20white%20background%2C%20professional%20after%20photo%2C%20visible%20skin%20improvement%2C%20smooth%20and%20bright%20skin&width=600&height=800&seq=after-002&orientation=portrait',
      treatment: 'Revcella フェイシャルコース',
      period: '2ヶ月（月2回×4回）',
    },
    {
      before: 'https://readdy.ai/api/search-image?query=Before%20scalp%20and%20hair%20condition%2C%20woman%20with%20thin%20hair%20volume%2C%20visible%20scalp%2C%20simple%20white%20background%2C%20professional%20hair%20assessment%20photo%2C%20before%20hair%20treatment%20documentation&width=600&height=800&seq=before-003&orientation=portrait',
      after: 'https://readdy.ai/api/search-image?query=After%20hair%20treatment%20result%2C%20woman%20with%20increased%20hair%20volume%2C%20fuller%20hair%2C%20improved%20scalp%20health%2C%20simple%20white%20background%2C%20professional%20after%20photo%2C%20visible%20hair%20improvement%2C%20thicker%20and%20healthier%20hair&width=600&height=800&seq=after-003&orientation=portrait',
      treatment: 'MOUMITU 頭皮ケアコース',
      period: '4ヶ月（月2回×8回）',
    },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section className="py-16 md:py-24 bg-white px-4">
      <div className="max-w-6xl mx-auto">
        <div className="mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-semibold text-dark-gray mb-3">
            変化を実感
          </h2>
          <div className="w-16 h-0.5 bg-gold"></div>
        </div>

        <div className="relative">
          <div className="overflow-hidden rounded-2xl">
            <div className="grid grid-cols-2 gap-2 md:gap-4">
              <div className="relative">
                <div className="w-full aspect-[3/4]">
                  <img
                    src={slides[currentSlide].before}
                    alt="Before"
                    className="w-full h-full object-cover rounded-xl"
                    style={{ filter: 'grayscale(100%)' }}
                  />
                </div>
                <span className="absolute top-4 left-4 bg-white/90 text-dark-gray px-3 py-1 rounded-full text-xs md:text-sm font-semibold">
                  Before
                </span>
              </div>
              <div className="relative">
                <div className="w-full aspect-[3/4]">
                  <img
                    src={slides[currentSlide].after}
                    alt="After"
                    className="w-full h-full object-cover rounded-xl"
                  />
                </div>
                <span className="absolute top-4 right-4 bg-gold text-white px-3 py-1 rounded-full text-xs md:text-sm font-semibold">
                  After
                </span>
              </div>
            </div>
          </div>

          <div className="mt-6 text-center">
            <p className="text-sm md:text-base text-medium-gray mb-1">
              {slides[currentSlide].treatment}
            </p>
            <p className="text-xs md:text-sm text-light-gray">
              {slides[currentSlide].period}
            </p>
          </div>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-4 mt-8">
            <button
              onClick={prevSlide}
              className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-gold text-gold hover:bg-gold hover:text-white transition-colors"
              aria-label="前へ"
            >
              <i className="ri-arrow-left-s-line text-xl"></i>
            </button>
            <div className="flex gap-2">
              {slides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-2 h-2 rounded-full transition-all ${
                    index === currentSlide ? 'bg-gold w-8' : 'bg-light-gray'
                  }`}
                  aria-label={`スライド${index + 1}`}
                ></button>
              ))}
            </div>
            <button
              onClick={nextSlide}
              className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-gold text-gold hover:bg-gold hover:text-white transition-colors"
              aria-label="次へ"
            >
              <i className="ri-arrow-right-s-line text-xl"></i>
            </button>
          </div>

          <p className="text-xs text-light-gray text-center mt-8">
            ※効果には個人差があります
          </p>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterSection;
